<template>
  <div class="base-report report-sales-staff">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.mode" size="mini" >
          <el-option
            v-for="item in modes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          height="100%"
          :summary-method="getSummaries">
          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && currentMode === modeType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <template v-if="!Array.isArray(subheader)">
                      <el-table-column
                      :key="subindex"
                      :label=subheader.label
                      :prop=subheader.prop
                      :min-width=subheader.width
                      align="right"
                      :sortable=subheader.sortable
                      :formatter="formatter">
                        <template v-if="Array.isArray(tableSetting[index + 1][subindex +1])">
                          <template v-for="(subheader2, subindex2) in tableSetting[index + 1][subindex +1]">
                            <el-table-column
                            :key="subindex2"
                            :label=subheader2.label
                            :prop=subheader2.prop
                            :min-width=subheader2.width
                            align="right"
                            :sortable=subheader2.sortable
                            :formatter="formatter">
                            </el-table-column>
                          </template>
                        </template>
                      </el-table-column>
                    </template>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

export default {
  name: 'ReportSalesStaff',
  data () {
    const modeType = {
      daily: 1,
      hourly: 2,
    }
    return {
      isLoading: false,
      noData: false,
      modeType: {...modeType},
      modes: [{value: modeType.daily, label: '日毎'}, {value: modeType.hourly, label: '時間'}],
      staticSetting: [
        {label: '年月日', prop: 'date', align: 'center', fixed: true, sortable: true, width: '130px'},
      ],
      tableSetting: [],
      searchForm: {
        mode: modeType.daily,
        from_date: null,
        to_date: null,
      },
      items: [],
      orgData: [],
      orgStaff: {},
      listStaff: {},
      minStaff: 4,
      currentMode: modeType.daily,
      totalData: [],
      csv_filename: '担当者別売上.csv',
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
    ]),
    ...mapGetters('holiday', ['holidays']),
    screenData () {
      let result = []
      switch (this.currentMode) {
        case this.modeType.daily:
          result.push(...this.generateDate())
          break
        case this.modeType.hourly:
          result.push(...this.generateHour())
          break
      }
      return result
    },
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.totalData = []
      this.orgData = []
      this.orgStaff = {}
      this.listStaff = {}
      this.currentMode = this.searchForm.mode

      this.$request.reports.salesStaffs(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method).then(res => {
        this.items = res.body

        for (let record of this.items.records) {
          this.orgData.push(record)
        }
        this.updateListStaff()
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    updateListStaff () {
      let orgData = this.orgData
      let result = {}

      for (let obj of orgData) {
        for (let record of obj.listStaff) {
          this.orgStaff[`${record.shopbaseId}${record.staffId}`] = {
            shopbaseId: record.shopbaseId,
            shopName: record.shopName,
            staffId: record.staffId,
            staffName: record.staffName,
          }
        }
      }
      Object.assign(result, this.orgStaff)

      // padding empty staff
      let staffNumber = Object.keys(result).length
      for (let i = 0; i < (this.minStaff - staffNumber); i++) {
        result['padding-' + i] = ''
      }

      this.listStaff = result
      this.updateTableSetting()
    },
    generateDate () {
      let orgData = this.orgData
      let listData = []

      for (let obj of orgData) {
        if (!obj.listStaff.length) {
          continue
        }

        let record = {}
        record.date = obj.targetDate
        for (let data of obj.listStaff) {
          let countKey = `staff-count-${data.staffId}-${data.shopbaseId}`
          let priceKey = `staff-price-${data.staffId}-${data.shopbaseId}`

          if (countKey in record) {
            record[countKey] += data.orderCount
            record[priceKey] += parseFloat(data.itemExcludeTaxTotalPrice)
          } else {
            record[countKey] = data.orderCount
            record[priceKey] = parseFloat(data.itemExcludeTaxTotalPrice)
          }
        }
        listData.push(record)
      }
      return listData
    },
    generateHour () {
      let orgData = this.orgData
      let listData = []
      let listId = {}

      for (let obj of orgData) {
        for (let data of obj.listStaff) {
          let hour = data.hour
          let countKey = `staff-count-${data.staffId}-${data.shopbaseId}`
          let priceKey = `staff-price-${data.staffId}-${data.shopbaseId}`
          let recordCur = listData[listId[hour]]

          if (!recordCur) {
            listId[hour] = listData.length
            let record = {}

            record.date = data.hour
            record[countKey] = data.orderCount
            record[priceKey] = parseFloat(data.itemExcludeTaxTotalPrice)
            listData[listId[hour]] = record
          } else {
            if (countKey in recordCur) {
              recordCur[countKey] += data.orderCount
              recordCur[priceKey] += parseFloat(data.itemExcludeTaxTotalPrice)
            } else {
              recordCur[countKey] = data.orderCount
              recordCur[priceKey] = data.itemExcludeTaxTotalPrice
            }
          }
        }
      }
      return listData.sort((a, b) => a.date - b.date)
    },
    updateTableSetting () {
      this.tableSetting = []
      this.tableSetting.push(...this.staticSetting)
      this.tableSetting[0].label = this.getDateStr()
      let shops = {}
      let listShop = {}
      Object.entries(this.listStaff).forEach(([staff, staffObj]) => {
        listShop[staffObj.shopbaseId] = staffObj.shopName

        if (!shops[staffObj.shopbaseId]) {
          shops[staffObj.shopbaseId] = []
        }
        shops[staffObj.shopbaseId].push({label: this.listStaff[staff].staffName})
        shops[staffObj.shopbaseId].push([
          {label: '件数', prop: `staff-count-${staffObj.staffId}-${staffObj.shopbaseId}`, sortable: true, width: '80px'},
          {label: '金額', prop: `staff-price-${staffObj.staffId}-${staffObj.shopbaseId}`, sortable: true, width: '120px'},
        ])
      })

      Object.entries(shops).forEach(([shop, value]) => {
        if (this.isGroupMode) {
          this.tableSetting.push({label: listShop[shop]})
          this.tableSetting.push(value)
        } else {
          this.tableSetting.push(...value)
        }
      })
    },
    getSummaries ({columns, data}) {
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let prop = columns[index].property
        let reducer = function (a, b) {
          let valb = parseFloat(b[prop]) || 0
          return a + valb
        }
        let values = data.reduce(reducer, 0)
        this.totalData[index] = this.formatData(prop, values)
      })
      return this.totalData
    },
    getHeaderAndKey ({header, keyList}, tableSetting, preHeader) {
      for (let tableHeader of tableSetting) {
        if (Array.isArray(tableHeader)) {
          let headerTitle = header.pop()
          if (!headerTitle) {
            continue
          }
          let tmp = this.getHeaderAndKey({header, keyList}, tableHeader, `${headerTitle}-`)
          header = tmp.header
          keyList = tmp.keyList
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          let tmpPreHeader = preHeader || ''
          header.push(tmpPreHeader + tableHeader.label)
        }
      }
      return {header: header, keyList: keyList}
    },
    exportCSV () {
      let header = []
      let keyList = []
      let nonePaddingSetting = []
      Object.entries(this.tableSetting).forEach(([setting, value]) => {
        if (value.label) {
          nonePaddingSetting.push(value)
          if (Array.isArray(this.tableSetting[parseInt(setting) + 1])) {
            nonePaddingSetting.push(this.tableSetting[parseInt(setting) + 1])
          }
        }
      })
      let tmp = this.getHeaderAndKey({header, keyList}, nonePaddingSetting)
      header = tmp.header
      keyList = tmp.keyList
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      let totalData = this.totalData.slice(0, header.length)
      downloadCSV(this.csv_filename, header, data, totalData)
    },
    date (value, isCsvData = false) {
      let result = '-'
      let date = moment(value)
      switch (this.currentMode) {
        case this.modeType.daily:
          result = date.locale('ja').format('YYYY/M/D')
          if (!isCsvData) {
            result = result + '(' + moment(value).locale('ja').format('ddd') + ')'
          }
          break
        case this.modeType.hourly:
          result = value + ':00〜' + value + ':59'
          break
      }
      return result
    },
    getDateStr () {
      let seft = this
      let rs = this.modes.filter((modes) => modes.value === seft.searchForm.mode)[0].label
      return rs
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      let result = !isNaN(value) ? value : 0

      switch (key) {
        case 'date':
          return this.date(value)
        default:
          break
      }
      result = key.includes('price') ? addFigure(parseFloat(result)) : result
      return result
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
.accum
  color: #606266
  vertical-align: middle
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesStaff.vue